import { render, staticRenderFns } from "./AddSocialMedia.vue?vue&type=template&id=5287663f&scoped=true&"
import script from "./AddSocialMedia.vue?vue&type=script&lang=js&"
export * from "./AddSocialMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5287663f",
  null
  
)

export default component.exports